<template>
    <div 
      class="base-image-container" 
      :style="containerStyle"
    >
      <img
        v-lazy
        :data-src="src"
        :alt="alt"
        class="base-image"
        :class="{ 'is-loaded': isLoaded }"
        @load="onLoad"
        @error="onError"
      >
      <div v-if="!isLoaded" class="image-placeholder">
        <slot name="placeholder">
          <div class="loading-spinner"></div>
        </slot>
      </div>
      <div v-if="error" class="error-placeholder">
        <slot name="error">
          <span>加载失败</span>
        </slot>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref , computed} from 'vue'
  
  const props = defineProps({
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    aspectRatio: {
      type: [Number, String],
      default: 'auto'
    }
  })
  
  const isLoaded = ref(false)
  const error = ref(false)
  
  const containerStyle = computed(() => ({
    paddingBottom: props.aspectRatio === 'auto' ? 'auto' : `${(1 / Number(props.aspectRatio)) * 100}%`
  }))
  
  const onLoad = () => {
    isLoaded.value = true
    error.value = false
  }
  
  const onError = () => {
    isLoaded.value = true
    error.value = true
  }
  </script>
  
  <style scoped>
  .base-image-container {
    position: relative;
    width: 100%;
    overflow: hidden;
  }
  
  .base-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0;
    transition: opacity 0.3s ease;
    display: block;
    
  }
  
  .base-image.is-loaded {
    opacity: 1;
  }
  
  .image-placeholder,
  .error-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #3498db;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  .error-placeholder {
    background-color: #f5f5f5;
    color: #666;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>